export const TOGGLE_EDIT_PDF_MODAL = 'TOGGLE_EDIT_PDF_MODAL'

export const toggleEditPDFModal = (show: boolean) => ({
  type: TOGGLE_EDIT_PDF_MODAL,
  show,
})
